type UserRights = {
  has: (right: string) => boolean;
};

// The report spans every module tab, so it is shown as soon as the user can
// read one of them: gating it on a single module would hide the summary from
// users who own the tab it summarizes.
const VERIFY_MODULE_RIGHTS = [
  "lcm_tabs.insertion_order",
  "lcm_tabs.asset_manager",
  "lcm_tabs.format_builder",
  "lcm_tabs.geo_planner",
  "lcm_tabs.footfall_settings",
  "lcm_tabs.campaign_overview",
  "lcm_tabs.tracking_manager",
];

export function canReadVerifyReport(rights: UserRights): boolean {
  return VERIFY_MODULE_RIGHTS.some(
    (right) => rights.has(`${right}_read`) || rights.has(`${right}_write`),
  );
}

// Running a verification writes a new report server-side, so it follows the
// write rights: any module write right is enough, mirroring the read rule.
export function canRunVerify(rights: UserRights): boolean {
  return VERIFY_MODULE_RIGHTS.some((right) => rights.has(`${right}_write`));
}
